export default __webpack_public_path__ + "static/media/44k.55a41282.md";